// src/services/newsService.js
import API_BASE_URL from "../config/apiConfig";
import createApiClient from "../config/apiClient";

const apiClient = createApiClient(API_BASE_URL);

// Lấy danh sách bài viết với pagination và filter
export const getNews = async (params = {}) => {
  try {
    const response = await apiClient.get("/news", { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

// Thống kê tin tức theo tháng (12 tháng gần nhất)
export const getNewsMonthlyStats = async () => {
  try {
    const response = await apiClient.get("/news/stats/monthly");
    return response.data?.data ?? { stats: [], total: 0 };
  } catch (error) {
    console.error('Error fetching news stats:', error);
    return { stats: [], total: 0 };
  }
};

// Thống kê tin tức theo ngày trong khoảng
export const getNewsStatsByRange = async (from, to) => {
  try {
    const response = await apiClient.get("/news/stats/daily", { params: { from, to } });
    return response.data?.data ?? { stats: [], total: 0 };
  } catch (error) {
    console.error('Error fetching news stats by range:', error);
    return { stats: [], total: 0 };
  }
};

// Lấy bài viết theo ID
export const getNewsById = async (id) => {
  try {
    const response = await apiClient.get(`/news/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching news:', error);
    throw error;
  }
};

// Lấy bài viết theo slug
export const getNewsBySlug = async (slug) => {
  try {
    const response = await apiClient.get(`/news/slug/${slug}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching news by slug:', error);
    throw error;
  }
};

// Tạo bài viết mới (admin only)
export const createNews = async (newsData) => {
  try {
    const response = await apiClient.post('/news', newsData);
    return response.data;
  } catch (error) {
    console.error('Error creating news:', error);
    throw error;
  }
};

// Cập nhật bài viết (admin only)
export const updateNews = async (id, newsData) => {
  try {
    const response = await apiClient.put(`/news/${id}`, newsData);
    return response.data;
  } catch (error) {
    console.error('Error updating news:', error);
    throw error;
  }
};

// Xóa bài viết (admin only)
export const deleteNews = async (id) => {
  try {
    const response = await apiClient.delete(`/news/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting news:', error);
    throw error;
  }
};
